/**
 * Back-compat re-export. The actual modal lives in
 * `client/src/components/Modals/GenerateReport/index.jsx` and is now
 * type-aware (Contact + Exhibition catalogues). New call sites should
 * import from there directly; this shim only exists so old imports
 * (`./Actions/GenerateReport`) keep working without churning every
 * navigation file in one go.
 */

export * from "../../../../components/Modals/GenerateReport";
